class ABinstagramFeed extends HTMLElement {
  connectedCallback() {
    this.config = {
      container: this.querySelector(".swiper"),
      wrapper: this.querySelector(".swiper-wrapper"),
      spinner: this.querySelector(".loading-spinner"),
      token: this.dataset.accessToken?.trim(),
      limit: parseInt(this.dataset.postLimit) || 6,
      desktop: parseInt(this.dataset.desktopPerSlide) || 4,
      mobile: parseInt(this.dataset.mobilePerSlide) || 3,
      autoplay: this.dataset.autoplay === "true",
      navigation: this.dataset.showNavigation === "true",
      nextBtn: this.querySelector(".swiper-button-next"),
      prevBtn: this.querySelector(".swiper-button-prev"),
      acceptFields: "id,media_type,media_url,permalink,thumbnail_url",
    };

    this.initSwiper();
    this.loadFeed();
  }

  initSwiper() {
    this.swiper = new Swiper(this.config.container, {
      slidesPerView: this.config.mobile,
      spaceBetween: 5,
      autoplay: this.config.autoplay
        ? { delay: 3000, disableOnInteraction: false }
        : false,
      navigation: this.config.navigation
        ? {
            nextEl: this.config.nextBtn,
            prevEl: this.config.prevBtn,
          }
        : false,
      breakpoints: {
        750: { slidesPerView: this.config.desktop },
      },
      loop: this.config.autoplay && this.config.limit > 2,
      grabCursor: true,
      watchOverflow: true,
      a11y: {
        enabled: true,
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
    });
  }

  async loadFeed() {
    if (!this.config.token) {
      this.showError("Instagram Access Token required");
      return;
    }
    try {
      const url = `https://graph.instagram.com/me/media?fields=${this.config.acceptFields}&limit=${this.config.limit}&access_token=${this.config.token}`;
      const response = await fetch(url);
      const feeds = await response.json();
      if (feeds.error) throw new Error(feeds.error.message);
      if (!feeds.data?.length) throw new Error("No posts found");
      this.renderFeeds(feeds.data);
    } catch (error) {
      this.showError(error.message);
    }
  }

  renderFeeds(feeds) {
    const slides = feeds
      .map((post) => {
        const isVideo = post.media_type === "VIDEO";
        const media = isVideo
          ? `<video muted loop playsinline autoplay poster="${
              post.thumbnail_url || ""
            }" loading="lazy" preload="metadata"><source src="${
              post.media_url
            }" type="video/mp4"></video>`
          : `<img src="${post.media_url}" alt="Instagram post" loading="lazy" decoding="async" fetchpriority="low">`;
        return `<div class="ab-insta-slide swiper-slide">
      <a href="${post.permalink}" target="_blank" rel="noopener">
        ${media}
      </a>
    </div>`;
      })
      .join("");

    this.config.wrapper.innerHTML = slides;
    this.config.spinner?.remove();
    this.swiper.update();

    this.swiper.on("slideChange", () => {
      const { activeIndex, slides } = this.swiper;
      this.config.prevBtn?.classList.toggle("show", activeIndex > 0);
      this.config.nextBtn?.classList.toggle(
        "show",
        activeIndex < slides.length - 1
      );
    });

    this.config.prevBtn?.classList.remove("show");
    this.config.nextBtn?.classList.toggle("show", feeds.length > 1);

    this.config.container.setAttribute("aria-hidden", "false");
    if (this.config.autoplay) this.swiper.autoplay.start();
  }
  showError(message) {
    this.config.wrapper.innerHTML = `<div class="insta-error">${message}</div>`;
    this.config.spinner?.remove();
    // Keep navigation hidden on error
    this.config.container.setAttribute("aria-hidden", "false");
  }
}

customElements.define("ab-instagram-feed", ABinstagramFeed);
